export default "__VITE_ASSET__Br4aQIEL__"